import { Component, NgZone, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../environments/environment'
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { Editor, Toolbar } from 'ngx-editor';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPopupComponent } from '../dialogs/confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.sass']
})
export class TemplatesComponent implements OnInit {
  pageSize: number = 100;
  pageIndex: number = 0;
  templatesListSubs: Subscription;
  templates: any;
  templateForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = true;
  modification_date: string;
  creation_date: string;
  logo_url: string;
  editor_es: Editor;
  editor_en: Editor;
  editor_cat: Editor;
  fontSizes: [8, 9, 10, 11, 12, 14, 18];
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    sanitize: false,
    uploadUrl: `${environment.API_URL}/api/uploadimg`, // if needed
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [

    ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'max-height100',
        class: 'max-height100'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };
  html: '';

  displayedColumns: string[] = ['name', 'type', 'modification_date', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;


  showTemplatesProgressBar: boolean = true;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private snackbar: MatSnackBar,
    private _dialog: MatDialog
  ) { }

  // public getTemplates() {
  //   this.templatesListSubs = this.dataService
  //     .getTemplates()
  //     .subscribe(res => {
  //       // 
  //       this.templates = res;
  //       this.templates = [{'id':"", 'name':""}].concat(this.templates)
  //       },
  //       console.error
  //     );
  // }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if(localStorage.getItem('templates'))
    {
      let data = JSON.parse(localStorage.getItem('templates'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1
    }
  }


  ngOnInit() {
    this.editor_es = new Editor();
    this.editor_en = new Editor();
    this.editor_cat = new Editor();
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')) {
        this.router.navigate(['/welcome']);
      }

    });
    this.templateForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      type: new FormControl('new_photo'),
      subject_es: new FormControl(''),
      editor_es: new FormControl(''),
      subject_en: new FormControl(''),
      editor_en: new FormControl(''),
      subject_cat: new FormControl(''),
      editor_cat: new FormControl('')
    });


    // this.templates = this.getTemplates();
    // this.routeSub = 



    this.route.params.subscribe(params => {
      this.dataService.getTemplates().subscribe(templates => {
        this.templates = templates;
        this.dataSource.data = this.templates;
        this.showTemplatesProgressBar = false;
      });
      if (params.id) {
        
        this.isList = false;
        if (params.id != 'new') {
          this.isNew = false;
          this.templatesListSubs = this.dataService
            .getTemplate(params.id) //cambiar por id en el html
            .subscribe(res => {
              
              this.templates = res;
              if(!this.route.toString().includes('duplicate'))
              {
                this.templateForm.controls["id"].setValue(this.templates.id);
              }

              this.templateForm.controls["name"].setValue(this.templates.name);
              this.templateForm.controls["subject_es"].setValue(this.templates.subject_es);
              this.templateForm.controls["editor_es"].setValue(atob(this.templates.editor_es.split(".").join("+")));
              this.templateForm.controls["subject_en"].setValue(this.templates.subject_en);
              this.templateForm.controls["editor_en"].setValue(atob(this.templates.editor_en.split(".").join("+")));
              this.templateForm.controls["subject_cat"].setValue(this.templates.subject_cat);
              this.templateForm.controls["editor_cat"].setValue(atob(this.templates.editor_cat.split(".").join("+")));
              this.templateForm.controls["type"].setValue(this.templates.type);
              this.creation_date = this.templates.creation_date;
              this.modification_date = this.templates.modification_date;
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }


      }
      else {
        this.isList = true;
      }
    });
  }
  ngOnDestroy(): void {
    this.editor_es.destroy();
    this.editor_es.destroy();
    this.editor_cat.destroy();
  }

  goTo(templateID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    localStorage.setItem('templates', JSON.stringify(data))
    this.router.navigateByUrl(`template/${templateID}`);
  }

  applyFilter(text: any) {
    const filterValue = (text.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public duplicateTemplate(template_id) {
    this.router.navigateByUrl(`template/${template_id}/duplicate`);
  }

  public async deleteTemplate(template_id: any) {
    let popupResponse = await this._dialog.open(ConfirmPopupComponent,
      { autoFocus: false, data: { title: this.translate.instant('alerts.confirm_action'), message: this.translate.instant('alerts.are_you_sure') }, panelClass: "no-padding", disableClose: true, width: '400px' }).afterClosed().toPromise()
    if (popupResponse)
    { 
      let params = {}
      params['id'] = template_id
      this.dataService.deleteTemplate(params).subscribe((res: any) => {
        
        if(res == 'success')
        {
          this.showTemplatesProgressBar = true;
          this.dataService.getTemplates().subscribe(templates => {
            this.templates = templates;
            this.dataSource.data = this.templates;
            this.showTemplatesProgressBar = false;
          });
        }
        else
        {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.no_permissions'), duration: 4000, panelClass: "error-snackbar" })
        }
      })
    }
  }

  newTemplate() {
    this.router.navigateByUrl(`template/new`);
  }
  sendEmailTest(templateID: string) {
    var params = {};
    params['templateID'] = templateID
    this.dataService
      .sendEmailTest(params) //cambiar por id en el html
      .subscribe(res => {

        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
      });
  }

  saveTemplate() {
    let text = btoa(this.templateForm.controls["editor_es"].value)
    var params = {};
    params['name'] = this.templateForm.controls["name"].value;
    params['id'] = this.templateForm.controls["id"].value;
    params['subject_es'] = this.templateForm.controls["subject_es"].value;
    params['editor_es'] =  btoa(this.templateForm.controls["editor_es"].value).split("+").join(".");
    params['subject_en'] = this.templateForm.controls["subject_en"].value;
    params['editor_en'] = btoa(this.templateForm.controls["editor_en"].value).split("+").join(".");
    params['subject_cat'] = this.templateForm.controls["subject_cat"].value;
    params['editor_cat'] = btoa(this.templateForm.controls["editor_cat"].value).split("+").join(".");
    params['type'] = this.templateForm.controls["type"].value;

    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
      })
      return false;
    }


    this.dataService.saveTemplate(params).subscribe(data => {
      if (data == '') {
        this.router.navigateByUrl(`templates`);
      }
      else {
        this.translate.get('alerts.save_template_error').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
        })
      }
    })
  }
}